<template>
  <div>
    <payment-data-table/>
  </div>
</template>

<script>
import PaymentDataTable from "../components/PaymentDataTable.vue"
export default {
  components: {
    "payment-data-table": PaymentDataTable
  }
}
</script>

<style>

</style>